import Vue from 'vue'
import Router from 'vue-router'

import userRoutes from './user'
import SellPage from '@/pages/sellPage/SellPage'
import BuyPage from '@/pages/marketplace/BuyPage'

Vue.use(Router)

const savedPositionRoutes = [
  'home',
  'category',
  'userFollowedUserPublications'
]

const HomePage = resolve => require(['@/pages/homePage'], resolve)
const CategoryPage = resolve => require(['@/pages/categoryPage'], resolve)
// const SellPage = resolve => require(['@/pages/sellPage'], resolve)
const PublicationPage = resolve => require(['@/pages/publicationPage'], resolve)
const OperationDetailsPage = resolve => require(['@/pages/operationDetailsPage'], resolve)
const HighlightsOrderPage = resolve => require(['@/pages/highlightsOrderPage'], resolve)
const ProfilePage = resolve => require(['@/pages/profilePage'], resolve)
const RegisterPage = resolve => require(['@/pages/others/RegisterPage'], resolve)
const MercadoPagoStatus = resolve => require(['@/pages/others/MercadoPagoStatus'], resolve)
const MarketplacePaymentStatus = resolve => require(['@/pages/others/MarketplacePaymentStatus'], resolve)
const SaleRefund = resolve => require(['@/pages/others/SaleRefund'], resolve)
const FaqPage = resolve => require(['@/pages/others/FaqPage'], resolve)
const TermsPage = resolve => require(['@/pages/others/TermsPage'], resolve)
const PrivacyPolicy = resolve => require(['@/pages/others/PrivacyPolicy'], resolve)
const NotFoundPage = resolve => require(['@/pages/others/NotFoundPage'], resolve)
const LoginRedirectPage = resolve => require(['@/pages/others/LoginRedirectPage'], resolve)
const PasswordResetPage = resolve => require(['@/pages/others/PasswordResetPage'], resolve)
const VerificationPage = resolve => require(['@/pages/others/VerificationPage'], resolve)
const ContactUs = resolve => require(['@/pages/others/ContactUs'], resolve)
const AdSalesPage = resolve => require(['@/pages/others/AdSalesPage'], resolve)
const UserProfilePage = resolve => require(['@/pages/user/ProfilePage'], resolve)

export const defaultTitle = 'MasPocoVendo.com — Clasificados gratis en Argentina'
const titleSuffix = ' — ' + defaultTitle

export default new Router({
  mode: 'history',

  scrollBehavior (to, from, savedPosition) {
    if (savedPosition && savedPositionRoutes.includes(to.name)) {
      return new Promise((resolve, reject) => {
        this.app.$root.$once('triggerScroll', () => {
          resolve(savedPosition)
        })
      })
    } else {
      return { x: 0, y: 0 };
    }
  },

  routes: [
    {
      path: '/',
      name: 'home',
      component: HomePage
    },
    {
      path: '/categoria/:category',
      name: 'category',
      component: CategoryPage
    },
    {
      path: '/publicar/:step?',
      name: 'sell',
      component: SellPage,
      meta: {
        title: 'Crear Publicación' + titleSuffix,
        requiresAuth: true
      }
    },
    {
      path: '/editar/:id?/:step?',
      name: 'editPublication',
      component: SellPage,
      meta: {
        title: 'Editar Publicación' + titleSuffix,
        requiresAuth: true
      }
    },
    {
      path: '/marketplace/authorization',
      name: 'authorization',
      component: UserProfilePage,
      meta: {
        title: 'Autorización MercadoPago',
        requiresAuth: true
      }
    },
    {
      path: '/destacar/:id?/:screen',
      name: 'highlights',
      component: HighlightsOrderPage,
      meta: {
        title: 'Destacar Publicación' + titleSuffix,
        requiresAuth: true
      }
    },
    /** Direct buy flow */
    {
      path: '/comprar/:id?/:step?/:order?',
      name: 'buy',
      component: BuyPage,
      meta: {
        title: 'Comprar Producto' + titleSuffix,
        requiresAuth: true
      }
    },
    {
      path: '/payment/:status',
      name: 'mercado-pago-status',
      component: MercadoPagoStatus,
      meta: {
        title: 'Pago via MercadoPago' + titleSuffix,
        requiresAuth: true
      }
    },
    {
      path: '/payment/marketplace/:status',
      name: 'buy-mercado-pago-status',
      component: MarketplacePaymentStatus,
      meta: {
        title: 'Pago de compra via MercadoPago' + titleSuffix,
        requiresAuth: true
      }
    },
    {
      path: '/refund/marketplace/:status',
      name: 'sale-refund',
      component: SaleRefund,
      meta: {
        title: 'Devolución via MercadoPago' + titleSuffix,
        requiresAuth: true
      }
    },
    {
      path: '/perfil/:username/:id',
      name: 'profile',
      component: ProfilePage
    },
    {
      path: '/cuenta/verificacion/:token?',
      name: 'userVerification',
      component: VerificationPage,
      meta: {
        title: 'Verificación de Cuenta de Usuario' + titleSuffix
      }
    },
    {
      path: '/cuenta/email/verificacion/:token?',
      name: 'emailVerification',
      component: VerificationPage,
      meta: {
        title: 'Verificación de Nuevo E-mail' + titleSuffix
      }
    },
    {
      path: '/ayuda/preguntas-frecuentes',
      name: 'faq',
      component: FaqPage,
      meta: {
        title: 'Preguntas Frecuentes' + titleSuffix
      }
    },
    {
      path: '/ayuda/contactanos',
      name: 'contact',
      component: ContactUs,
      meta: {
        title: 'Contactanos' + titleSuffix
      }
    },
    {
      path: '/ayuda/terminos',
      name: 'terms',
      component: TermsPage,
      meta: {
        title: 'Términos y Condiciones' + titleSuffix
      }
    },
    {
      path: '/ayuda/politica-de-privacidad',
      name: 'privacy',
      component: PrivacyPolicy,
      meta: {
        title: 'Política de Privacidad' + titleSuffix
      }
    },
    {
      path: '/cuenta/registro',
      name: 'register',
      component: RegisterPage
    },
    {
      path: '/clave/reiniciar/:token',
      name: 'passwordReset',
      component: PasswordResetPage,
      meta: {
        title: 'Reseteo de Contraseña' + titleSuffix
      }
    },
    {
      path: '/vende-con-nosotros',
      name: 'sales',
      component: AdSalesPage,
      meta: {
        title: 'Reseteo de Contraseña' + titleSuffix
      }
    },
    {
      path: '/login/:social/callback',
      component: LoginRedirectPage
    },
    ...userRoutes,
    {
      path: '/operacion/:id(\\d+)/:merchant(\\d+)',
      name: 'operation',
      component: OperationDetailsPage,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/:title/:id(\\d+)',
      name: 'publication',
      component: PublicationPage
    },
    // {
    // // Legacy category URL
    //   path: '/:category/:subcategory',
    //   redirect: to => {
    //     const { hash, params, query } = to
    //     return { path: '/categoria/todas', query: { q: params.subcategory.replace(/-/g, ' ') } }
    //   }
    // },
    // // Legacy publication URL
    // { path: '/:city/:cat/:title/:id',
    //   redirect: to => {
    //     const { hash, params, query } = to
    //     return { path: '/categoria/todas', query: { q: params.title.replace(/-/g, ' ') } }
    //   }
    // },
    {
      path: '/error/404',
      name: 'notFound',
      component: NotFoundPage
    },
    {
      path: '*',
      component: NotFoundPage
      // redirect: {name: 'notFound', query: {}, params: {}}
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/router.js